module.exports = __webpack_public_path__ + "img/pic-paging-service4-2.27878b1a.jpg";